import React from 'react';
import useResourceProgress from 'components/Hooks/useResourceProgress';
import Player from './Player';

const AudioPlayerWithProgress = props => {
  const { audioId } = props;

  const { initialTime, processing, onProgressUpdate } = useResourceProgress({
    resourceId: audioId,
    resourceType: 'audio',
  });

  if (processing) return null;

  return (
    <Player
      {...props}
      initialTime={initialTime}
      onProgressUpdate={onProgressUpdate}
    />
  );
};

export default AudioPlayerWithProgress;
